export const FEATURE_FLAGS = {
  OPERATIONAL_MEDPREV_WEB_APP_LEVEL_TWO: 'operational-medprev-web-app-level-two',
  OPERATIONAL_MEDPREV_WEB_APP_LEVEL_THREE: 'operational-medprev-web-app-level-three',
  OPERATIONAL_MEDPREV_WEB_APP_SWITCH_FLEX_TO_WHATSAPP: 'operational-medprev-web-app-switch-flex-to-whatsapp',
  OPERATIONAL_MEDPREV_WEB_APP_SCHEDULED_SLOTS_INLINE: 'operational-medprev-web-app-scheduled-slots-inline',
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];
